import React from "react";
import SectionHeader from "../section/SectionHeader.js";
import kitchenBg from "../../../assets/images/banner-back-1.jpg";
import QuoteForm from "../../QuoteForm.js";
import Navbar4 from "../../Navbar4.js";
import Cards from "../../cards/Card.js";
const KitchenRenovation = () => {
  return (
    <div className="container-fluid">
      <SectionHeader
        title="KITCHEN RENOVATIONS"
        backgroundImage={kitchenBg}
        className=""
      />
      <div className="container my-3">
        <div className="row">
          <div className="col-lg-9">
            <div className="px-1 my-4">
              <h1 data-sal="slide-right" data-sal-duration="2000" data-sal-delay="300"
                className="text-center mb-4"
                style={{
                  fontFamily: "Barlow Condensed",
                  fontWeight: "normal",
                  fontSize: "2rem",
                }}
              >
                Kitchen Renovations
              </h1>
              <img data-sal='slide-right' data-sal-duration="2000" data-sal-delay="800"
            className="mb-3"
            src="assets/Images/Kitchen/kitch-5.webp"
            alt="banner"
            style={{
              width: "100%",
              float: "left",
              height: "200px",
              objectFit: "cover",
              marginTop: "0px", 
            }}
          />

              <p
                className="text-start my-4"
                style={{ fontFamily: "Barlow Condensed" }}
              >
                The kitchen is truly the heart of any home—a space where
                families gather in the morning to start their day and reconnect
                in the evening to share their experiences. It’s where friends
                come together over dinner and loved ones enjoy festive feasts.
                Food has a unique way of bringing people together, and your
                kitchen should offer a warm, inviting environment for both
                cooking and entertaining. At Velar Heights Renovations, we
                believe that a kitchen renovation is about more than just new
                cabinets and countertops—it’s about creating a space that feels
                right whether you’re brewing your morning coffee or preparing a
                special meal for loved ones.
              </p>

              <h2 data-sal='slide-left' data-sal-duration="2000" data-sal-delay="800"
                className="text-start"
                style={{
                  fontFamily: "Barlow Condensed",
                  fontWeight: "normal",
                  fontSize: "1.5rem",
                }}
              >
                Modern Kitchen Renovations
              </h2>

              <p
                className="text-start"
                style={{ fontFamily: "Barlow Condensed" }}
              >
                In Toronto, modern kitchen renovations for homes and condos are
                a far cry from those of the past. Today’s renovations often
                require extensive upgrades to accommodate contemporary
                lifestyles, including expanded cooking areas and significant
                improvements in electrical, plumbing, and HVAC systems to
                support advanced appliances and enhanced lighting.One of the
                most popular trends is the open-concept design, where walls are
                removed to integrate the kitchen with the living area. Solid
                surface countertops, like engineered quartz, granite, wood, and
                stainless steel, are now favored for their easy maintenance and
                ability to accommodate desirable undermount sinks.
              </p>

              <h2 data-sal='slide-right' data-sal-duration="2000" data-sal-delay="800"
                className="text-start"
                style={{
                  fontFamily: "Barlow Condensed",
                  fontWeight: "normal",
                  fontSize: "1.5rem",
                }}
              >
                Experts at Your Service
              </h2>

              <p
                className="text-start"
                style={{ fontFamily: "Barlow Condensed" }}
              >
                Our skilled and reliable team excels in every aspect of kitchen
                remodeling. We offer a full range of services, from individual
                room upgrades to complete home renovations, ensuring that every
                space is thoughtfully designed and beautifully executed. From
                the initial planning and design stages to project management and
                construction, we are committed to making your renovation a
                success. Whether you’re revamping a single room or undertaking a
                whole-home makeover, we’re here to enhance both the value and
                appeal of your space.Kitchen islands, offering seating and
                generous workspace, serve as a social hub between the kitchen
                and living spaces. Additionally, appliances and finishes have
                become more practical and visually appealing, blending
                seamlessly with the living area. Enhanced lighting, including
                potlights, additional outlets, and undercounter LED lighting,
                has also become a key feature, even in the most straightforward
                kitchen renovations.
              </p>
            </div>
          </div>

          <div className="col-lg-3 d-flex flex-column justify-content-start">
        <div className="mb-3" style={{ marginTop: '85px' }}> 
          <QuoteForm />
        </div>
        <Navbar4 />
      </div>
        </div>
      </div>

      <div >
        <h1 data-sal='slide-down' data-sal-duration="2000" data-sal-delay="800"
          className="text-center  "
          style={{
            fontFamily: "Barlow Condensed",
            fontWeight: "lighter",
            fontSize: "4rem",
          }}
        >
          Our Portfolio
        </h1>

        <Cards />
      </div>
    </div>
  );
};

export default KitchenRenovation;
